import { trigger, transition, query, style, animate } from '@angular/animations';

export const routeAnimations = trigger('routeAnimations', [
  transition('* => forward', [
    query(':enter', [
      style({ transform: 'translateX(100%)', opacity: 0 }),
      animate('250ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
    ], { optional: true }),
  ]),
  transition('* => back', [
    query(':enter', [
      style({ transform: 'translateX(-100%)', opacity: 0 }),
      animate('250ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
    ], { optional: true }),
  ]),
]);
